/* eslint-disable react/prop-types */
import { FC, ReactNode } from 'react';
import { useTableHeightSync } from 'modules/benefitsWellness/components/TableContext/TableContextProvider';

type SyncedLabelProps = {
  fieldName: string;
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
  isEditMode?: boolean;
  adjustedHeight?: number;
};

const SyncedLabel: FC<SyncedLabelProps> = ({
  fieldName,
  children,
  className,
  style = {},
  isEditMode = false,
  adjustedHeight,
}) => {
  const { height, ref } = useTableHeightSync(fieldName, -1);
  const calculatedHeight =
    (adjustedHeight || 0) > (height || 0) ? adjustedHeight : height;
  return (
    <div
      ref={ref}
      style={
        !isEditMode && calculatedHeight
          ? { ...style, height: calculatedHeight }
          : style
      }
      className={className}
    >
      {children}
    </div>
  );
};

export default SyncedLabel;
